<template>
  <div class="screen-root stamp" :class="{ incein: isIncein }">
    <div v-if="showIntro" class="intro-text">
      {{ introText || screenName }}
    </div>
    <template v-else>
      <div class="screen-titles" :class="{ invisible: blank && !error }">
        <div v-if="error" class="error-info">
          <img src="../../assets/common/error.png" alt="Error" />
          <p class="mt-6" v-html="screenInfo"></p>
        </div>
        <template v-else>
          <h2 class="screen-name">{{ screenName }}</h2>
          <h1 class="screen-info" v-html="screenInfo"></h1>
        </template>
      </div>
      <div class="content-container">
        <slot></slot>
      </div>
      <p class="alt-info" v-html="altInfo"></p>
    </template>
    <img class="voice-pic" src="../../assets/stamp/voice.svg" />
    <img
      v-if="canSkip && !showIntro"
      class="cancel-btn"
      src="../../assets/common/cross.svg"
      @click="$emit('skip')"
    />
    <slot name="audio"></slot>
  </div>
</template>

<script>
import scanScreen from '@/mixins/scan-screen';
import incein from '@/mixins/incein';

export default {
  name: 'Screen',
  mixins: [scanScreen, incein],
};
</script>

<style lang="scss" scoped>
.screen-root {
  @apply flex-col w-full h-full flex justify-center items-center;
  &.stamp {
    background-color: rgb(14, 14, 14);
    .screen-name {
      color: rgb(212, 212, 212);
      font-size: 18px;
    }
    .screen-info,
    .alt-info {
      color: rgb(245, 245, 245);
    }
  }
  &.incein {
    background-color: #fafaf9;
    color: #262326;
    .screen-name,
    .screen-info,
    .intro-text,
    .alt-info {
      color: #262326;
    }
  }
}

.screen-titles {
  @apply flex flex-col w-full text-left mt-20 px-20;
  height: 200px;
}
.screen-name {
  font-weight: 500;
  line-height: 1.25;
}
.screen-info {
  @apply text-center font-bold mt-5;
  @screen lg {
    @apply mt-20;
    font-size: 32px;
  }
  font-size: 28px;
  line-height: 1.5;
}
.intro-text {
  @apply mx-auto text-center flex flex-1 flex-col justify-center overflow-visible w-full pt-10;
  font-size: 33px;
  color: rgb(206, 221, 229);
}
.content-container {
  @apply flex flex-1 flex-col justify-center overflow-visible w-full px-20 pt-8 pb-20;
}
.error-info {
  @apply mx-auto;
  color: red;
  font-size: 30px;
  @screen lg {
    @apply mt-16;
    font-size: 32px;
  }
  img {
    @apply mx-auto;
    width: 10%;
  }
}
.voice-pic {
  @apply fixed bottom-0 left-0 w-full mt-auto;
}
.cancel-btn {
  @apply absolute top-0 right-0 mt-16 mr-20 cursor-pointer;
}
.alt-info {
  @apply mb-32 text-center;
  font-size: 18px;
  max-width: 70%;
  @screen lg {
    @apply mb-56;
    font-size: 24px;
  }
}
</style>
